'use client';

import { useProduct } from '@/contexts/ProductContext';
import YotpoStars from '@/components/global/yotpo/YotpoStars';

// BL-648: only field so far, and the only h1 the page gets when the V2 flag
// is on — page.js renders BuyBoxV2 instead of ProductDetails, so V1's
// ProductMasthead (and its h1) never mounts.
const V2Masthead = ({ block }) => {
  const { productData } = useProduct();
  const shopifyProductId = productData?.shopify_product_id;
  const productUrl = productData?.url;

  const { product_name, visible_review_stars } = block;

  const handleReviewsClick = (e) => {
    const target = e.target.closest('a');
    if (!target) return;
    const reviewsSection = document.querySelector('[data-name="product-reviews"]');
    if (!reviewsSection) return;
    e.preventDefault();
    reviewsSection.scrollIntoView({ behavior: 'smooth' });
  };

  // BL-648 review: stars sit above the product title, matching the Helix
  // reference Richard linked.
  //
  // `mb-2` per Richard's review on PR #301, and it tracks the reference: star
  // ink bottom → title glyph top measures 17px here against Helix's 15px, both
  // taken the same way in DevTools rather than inferred from their markup.
  //
  // Don't tighten this back up. The 8px margin stacks on 5px of YotpoStars'
  // min-h-[19px] CLS reserve below the stars and 4px of h1 half-leading above
  // the glyph, so the previous -mb-0.5 measured ~7px — 8px tighter than Helix,
  // which is what the review was correcting. Their negative
  // calc(-0.75rem - 2px) is not transferable: they run yotpo-widget-instance
  // (15px stars in a 28px row) where we run the legacy bottomLine widget, so it
  // offsets padding our markup never had.
  return (
    <div className="font-worksans mt-4 md:mt-0" data-block="v2_masthead">
      {visible_review_stars && shopifyProductId && (
        <div onClick={handleReviewsClick} className="mb-2 cursor-pointer mt-4">
          <YotpoStars productId={shopifyProductId} url={productUrl} />
        </div>
      )}

      {product_name && (
        <h1 className="font-cormorant text-primary text-[32px] font-semibold capitalize">
          {product_name}
        </h1>
      )}
    </div>
  );
};

export default V2Masthead;
